<template>
  <div class="md-layout p-0">
    <div
      class="md-layout-item md-size-50 md-small-size-100"
      v-for="(card, index) in dataSynthetic"
      :key="card.title + index"
    >
      <card-report :icon="card.icon" :title="card.title" :heightFull="`h-full`">
        <div
          class="font-medium text-lg max-w-[70%] block overflow-hidden overflow-ellipsis whitespace-nowrap"
        >
          {{ card.info }}
        </div>
      </card-report>
    </div>
  </div>
</template>
<script>
import CardReport from "../../Components/CardReport";
export default {
  name: "synthetic-student",
  components: { CardReport },
  props: ["data"],
  computed: {
    dataSynthetic() {
      return [
        {
          icon: "fas fa-user-graduate",
          title: this.$t("dashboard.synthetic.program_name"),
          info: this.data.program_name || "No program"
        },
        {
          icon: "fas fa-file-alt",
          title: this.$t("dashboard.synthetic.total_enrolled_classes"),
          info: this.data.total_enrolled_classes || 0
        },
        {
          icon: "fas fa-file-alt",
          title: this.$t("dashboard.synthetic.gpa"),
          info: this.data.cpa || 0
        },
        {
          icon: "fas fa-file-alt",
          title: this.$t("dashboard.synthetic.gpa_with_bonus_point"),
          info: this.data.cpa_wbonus_point || 0
        }
      ];
    }
  }
};
</script>
